import React from 'react'
import { Box } from '@chakra-ui/react'
import { MatchedSearchIndexes } from './SelectEntitiesForm.types'

type HighlightMatchedStringProps = {
  text: string
  matches: MatchedSearchIndexes[]
}

type TermProps = {
  highlight?: boolean
}

const Term: React.FC<TermProps> = ({ children, highlight }) => (
  <Box bgColor={highlight ? 'yellow.200' : ''} as="span">
    {children}
  </Box>
)

const processMatches = (text: string, matches: MatchedSearchIndexes[]) => {
  let term = ''

  const highlightedTerms = matches.reduce((acc, matchItemIndices) => {
    const result: React.ReactNode[] = []
    const normalizedMatches = [...matchItemIndices]
    let pair = normalizedMatches.shift()

    for (let i = 0; i < text.length; i++) {
      const char = text.charAt(i)

      if (pair && i === pair[0]) {
        result.push(<Term key={i + term}>{term}</Term>)
        term = ''
      }

      term += char

      if (pair && i === pair[1]) {
        result.push(
          <Term highlight key={i + term}>
            {term}
          </Term>
        )
        term = ''
        pair = normalizedMatches.shift()
      }
    }

    return [...acc, result]
  }, [] as React.ReactNode[])

  if (term) {
    highlightedTerms.push(<Term key={'last-term'}>{term}</Term>)
  }

  return highlightedTerms
}

export const HighlightMatchedStringComponent: React.FC<HighlightMatchedStringProps> =
  ({ text, matches }) => {
    if (matches && matches.length) {
      return <div>{processMatches(text, matches)} </div>
    }

    return <span>{text}</span>
  }
export const HighlightMatchedString = React.memo(
  HighlightMatchedStringComponent
)
